import { TransactionStateSelectV2 } from '@frontend/transaction/components';
import { TransactionStateName } from '@frontend/transaction/types';

export interface TransactionStateFieldProps {
    onChange: (value: string | null) => void;
    value: string | null;
    disabled?: boolean;
    className?: string;
    label?: React.ReactNode;
    required?: boolean;
    isClearable?: boolean;
}

export const TransactionStateField = (props: TransactionStateFieldProps) => {
    return (
        <TransactionStateSelectV2
            {...props}
            isClearable={props.isClearable ?? true}
            onSelect={(value) => props.onChange(value?.value ?? null)}
            value={props.value as TransactionStateName | null}
        />
    );
};
